import api from '../api';

function createService(path, entityKey = 'code') {
  return {
    fetch: async () => api.get(`/${path}`),
    create: async ({ entity }) => api.post(`/${path}`, entity),
    update: async ({ entity, originalEntity }) => {
      if (!originalEntity) {
        throw new Error(`${entityKey} original entity not found`);
      }
      if (!originalEntity[entityKey]) {
        throw new Error(`${entityKey} key not found`);
      }

      return api.put(`/${path}/${originalEntity[entityKey]}`, entity);
    },
  };
}

const RegionService = createService('regions');
const ProvinceService = createService('provinces');
const DistrictService = createService('districts');
const SubdistrictService = createService('subdistricts');
const PostalCodeService = createService('postalCodes', 'id');

export const ADDRESS_SOURCES = {
  region: { name: 'regions', service: RegionService },
  province: { name: 'provinces', service: ProvinceService },
  district: { name: 'districts', service: DistrictService },
  subdistrict: { name: 'subdistricts', service: SubdistrictService },
  postalCode: { name: 'postalCodes', service: PostalCodeService },
};
